import { Routes } from '@angular/router';
import { FindUsers } from './components/users/find-users/find-users';
import { AuthGuard } from '@anddone/ui-utilities';
import { UsersDetails } from './components/users/users-details/users-details';
import { FindPayments } from './components/payments/find-payments/find-payments';
import { PaymentDetails } from './components/payments/payment-details/payment-details';
import { WebhookManagement } from './components/webhooks/webhook-management/webhook-management';
import { WebhookDetails } from './components/webhooks/webhook-details/webhook-details';
import { FindWebhookEventLogs } from './components/webhooks/find-webhook-event-logs/find-webhook-event-logs';
import { Reports } from './components/reports/reports/reports';
import { GeneratedReports } from './components/reports/generated-reports/generated-reports';
import { UserChangePassword } from './components/user-profile/user-change-password/user-change-password';
import { FindNotifications } from './components/notifications/find-notifications/find-notifications';
import { NotificationDetails } from './components/notifications/notification-details/notification-details';

export const secureRoutes: Routes = [
  {
    path: 'users',
    pathMatch: 'full',
    component: FindUsers,
    canActivate: [AuthGuard],
  },
  {
    path: 'user/:id',
    pathMatch: 'full',
    component: UsersDetails,
    canActivate: [AuthGuard],
  },
  {
    path: 'payments',
    pathMatch: 'full',
    component: FindPayments,
    canActivate: [AuthGuard],
  },
  {
    path: 'payments/details/:id',
    // pathMatch: 'full',  // commented by Joe for now to handle dynamic URL on payment details page from table component
    component: PaymentDetails,
    canActivate: [AuthGuard],
  },
  {
    path: 'webhooks',
    pathMatch: 'full',
    component: WebhookManagement,
    canActivate: [AuthGuard],
  },
  {
    path: 'webhook-details/:id',
    pathMatch: 'full',
    component: WebhookDetails,
    canActivate: [AuthGuard],
  },
  {
    path: 'webhook-events',
    pathMatch: 'full',
    component: FindWebhookEventLogs,
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    pathMatch: 'full',
    component: Reports,
    canActivate: [AuthGuard],
  },
  {
    path: 'reports/generate-reports/:tableRoute',
    pathMatch: 'full',
    component: GeneratedReports,
    canActivate: [AuthGuard],
  },
  {
    path: 'user-profile/:id',
    pathMatch: 'full',
    component: UsersDetails,
    canActivate: [AuthGuard],
  },
  {
    path: 'profile/change-password',
    pathMatch: 'full',
    component: UserChangePassword,
    canActivate: [AuthGuard],
  },
  {
    path: 'notifications',
    pathMatch: 'full',
    component: FindNotifications,
    canActivate: [AuthGuard],
  },
  {
    path: 'notifications/details/:id',
    pathMatch: 'full',
    component: NotificationDetails,
    canActivate: [AuthGuard],
  },
];
